import { useTranslation } from 'react-i18next';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import { toast, ToastContainer } from 'react-toastify';
import { AppContext } from "../../utils/context/app.context.js";
import FormComponent from '../../utils/components/form.component';
import systemService from '../../services/system.service.js';
import { Icon } from '@blueprintjs/core';

export default function SignIn() {
    const { t } = useTranslation();
    const appContext = useContext(AppContext);
    const navigate = useNavigate();
    const [personType, setPersonType] = useState('N');
    const [created, setCreated] = useState(false);

    function onChangePersonType(e) {
        setPersonType(e.target.value)
    }

    function onSubmit(form) {
        toast.info(t('actions.procesing'));
        systemService.app_signin(form)
            .then(res => {
                if (res.data) {
                    toast.dismiss();
                    toast.success(t('signin.userCreaated'));
                    setCreated(true);
                }
            })
            .catch(error => appContext.errorHandler(error, toast, t))
    }

    const passRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/;

    const FORM = () => [
        {
            title: t('signin.form.section'),
            inputs: [
                [
                    { id: "tipo", required: true, title: t('signin.form.tipo'), placeholder: t('signin.form.tipo'), icon: "tag", type: "select", list: [{ value: 'N', text: t('personas.form.N') }, { value: 'J', text: t('personas.form.J') }], onChange: onChangePersonType },
                    { id: "name", required: true, title: t('signin.form.nombre'), placeholder: t('signin.form.nombre'), icon: "person", },
                ],
                [
                    { id: "cedula_nit", required: true, title: t('signin.form.cedula_nit2'), placeholder: t('signin.form.cedula_nit'), icon: "id-number", format: personType === 'N' ? appContext.formatId : appContext.formatNit, max: personType === 'N' ? null : 12 },
                    { id: "ciudad", required: true, title: t('signin.form.ciudad'), placeholder: t('signin.form.ciudad'), icon: "home", type: "list", list: appContext.getCityList() },
                    { id: "direccion", required: true, title: t('signin.form.direccion'), placeholder: t('signin.form.direccion'), icon: "home", },
                ],
                [
                    { id: "telefono", required: true, title: t('signin.form.telefono'), placeholder: t('signin.form.telefono'), icon: "phone", format: appContext.formatPhone },
                    { id: "correo", required: true, title: t('signin.form.correo'), placeholder: t('signin.form.correo'), icon: "at", pattern: appContext.emailPattern },
                ],
                [
                    { id: "login", title: t('signin.form.login'), placeholder: t('signin.form.login'), icon: "user", required: true, min: 8, max: 64, },
                    { id: "pass", title: t('signin.form.pass2'), placeholder: t('signin.form.pass'), icon: "key", required: true, type: "password", max: 16, min: 8, pattern: passRegex, },
                ],
            ]
        },
    ]

    return (

        <div className="app-container">
            <div className="app-overlay">
                <div className="row m-0 p-o">
                    <div className="container">
                        <div className="row justify-content-center m-5">
                            <div className="col-md-6 col-sm-12">

                                <div className='signin-container pb-3 px-2'>
                                    <ToastContainer theme="colored" />
                                    <h2>{t("signin.title")}</h2>
                                    <hr />

                                    {created ? <>
                                        <div className="text-center mb-4"><Icon icon={'tick-circle'} size={96} color="#5e4239" /></div>
                                        <h2 className="text-center">{t("signin.createdTitle")}</h2>
                                        <h4>{t("signin.createdP")}</h4>
                                        <h3 className="text-center"><a href="#" onClick={() => navigate("/login")}>{t("signin.createdLink")}</a></h3>
                                    </> :
                                        <FormComponent
                                            actions={{
                                                primary: { icon: "add", text: t('actions.signin') },
                                                secondary: { icon: "arrow-left", text: t('actions.back') }
                                            }}
                                            onSecondary={() => navigate("/login")}
                                            onSubmit={(data) => onSubmit(data)}
                                            groups={FORM()}
                                            footer={<>
                                                <div className='row'>
                                                    {t("signin.passreq")}
                                                </div>
                                                <div className='row pt-2'>
                                                    {t("signin.cedula_nit_req")}
                                                </div>
                                            </>}
                                        />
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
